import { dispatch } from "../../../app/store";
import { fetchPersonalGlobalPref, savePersonalPreferenceApi } from "./global-pref-slice";

const fetchGlobalPref = (payload) => dispatch(fetchPersonalGlobalPref(payload));
const saveGlobalPersonalPref = ({ username, data }) =>
  dispatch(savePersonalPreferenceApi({ personal : username, data}));


export { fetchGlobalPref, saveGlobalPersonalPref };
